import React from "react";

import { FiArrowLeft } from "react-icons/fi";

const ConsentPage = ({
  selectedBankId,
  getBank,

  setPaymentHistoryTab,
  setScreen,
}) => {
  const selectedBank = getBank(selectedBankId);

  return (
    <section className="fw-screen fw-screen--bank fw-fade">
      <div className="fw-bank-top">
        <button
          type="button"
          className="fw-bank-back"
          onClick={() => setScreen("/apply-new/aaAccount")}
          aria-label="Back"
        >
          <FiArrowLeft />
        </button>

        <h1>Account Aggregator Verification testd</h1>
      </div>

      <div className="fw-bank-scroll">
        <h2 className="fw-bank-section-title">
          Account Summary testd 
        </h2>

        <div className="fw-summary-card">
          <span
            className="fw-bank-logo fw-bank-logo--sm"
            style={{
              background: selectedBank.color,
            }}
          >
            {selectedBank.name.charAt(0)}
          </span>

          <div>
            <strong>{selectedBank.name}</strong>

            <small>XXXXXXXXXX7797</small>

            <em>Savings Account</em>
          </div>
        </div>

        <h2 className="fw-bank-section-title">
          Consent
        </h2>

        <div className="fw-consent-card">
          <div className="fw-consent-card__head">
            <label>
              <input
                type="checkbox"
                defaultChecked
                readOnly
              />

              {" "}ONETIME
            </label>

            <button type="button">
              More details
            </button>
          </div>

          <p>
            <b>Consent Period</b>{" "}
            07/May/2025 - 07/Aug/2025
          </p>

          <p>
            <b>Data Life</b> 1 month
          </p>

          <p>
            <b>Frequency</b> 1 time per month
          </p>

          <div className="fw-consent-tags">
            <button
              type="button"
              onClick={() =>
                setScreen("/apply-new/profile")
              }
            >
              Profile
            </button>

            <button
              type="button"
              onClick={() => {
                setPaymentHistoryTab("loans");
                setScreen("/apply-new/paymentHistory");
              }}
            >
              Summary
            </button>

            <button
              type="button"
              onClick={() => {
                setPaymentHistoryTab(
                  "transactions"
                );

                setScreen("/apply-new/paymentHistory");
              }}
            >
              Transactions
            </button>
          </div>

          <p>
            <b>Purpose</b>{" "}
            To assess your loan eligibility
          </p>
        </div>
      </div>

      <div className="fw-screen__footer fw-bank-footer-actions">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={() =>
            setScreen("/apply-new/aaAccount")
          }
        >
          Decline
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--dark"
          onClick={() =>
            setScreen("/apply-new/bankSuccess")
          }
        >
          Agree
        </button>
      </div>

      <p className="fw-powered">
        Powered by <b>FUNDSWALLE</b>
      </p>
    </section>
  );
};

export default ConsentPage;